<template>
  <div>
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>资产管理</el-breadcrumb-item>
        <el-breadcrumb-item>商品管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="operating">
      <span> <el-button type="primary" size="small" @click="addDialog()" >新增商品</el-button></span>
    </div>
    <div >
      <template>
        <el-table
          :data="tableData"
          stripe
          center
          border
          highlight-current-row
          @filter-change="filterStatusHandler"
          @sort-change="changeColumnSort"
          style="width: 100%">
          <el-table-column
            align="center"
            prop="game_name"
            label="游戏名称"
            filter-multiple
            column-key="game_id"
            :filters=gamesList>
          </el-table-column>
          <el-table-column
          align="center"
          label="商品图片">
          <template slot-scope="scope">
            <el-image :src="scope.row.icon" alt="" style="height: 40px; width: 40px">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </template>
        </el-table-column>
          <el-table-column
            align="center"
            prop="name"
            label="商品名称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="en_name"
            label="英文名称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="price"
            label="价格（美元）"
            sortable="custom">
          </el-table-column>
          <el-table-column
            align="center"
            prop="commodity_id"
            label="商品ID">
          </el-table-column>
          <el-table-column
            align="center"
            label="上架状态">
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.is_shelves?'上架':'下架'" placement="top">
                <el-switch
                  v-model="scope.row.is_shelves"
                  @change="handleChangeStatus(scope.row, 'shelves_status','is_shelves')"
                  active-color="#13ce66"
                  inactive-color="#DCDFE6">
                </el-switch>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="操作"
            width="140">
            <template slot-scope="scope" >
              <el-button
                type="primary"
                size="small"
                @click="editDialog(scope.row.id)">编辑
              </el-button>
              <el-popconfirm
                confirmButtonText='确定'
                cancelButtonText='返回'
                icon="el-icon-info"
                iconColor="red"
                title="删除不可恢复，确定删除吗？"
                @onConfirm="del(scope.row.id)"
              >
                <el-button type="primary" size="small" slot="reference">删除</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        <div class="block page-box">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page=page
            :page-sizes="[50, 100, 200, 500]"
            :page-size=page_size
            layout="total, sizes, prev, pager, next, jumper"
            :total=total>
          </el-pagination>
        </div>
      </template>
    </div>
    <el-dialog :title="dialogTitle" :visible.sync="dialogAddVisible" :close-on-click-modal="false" width="600px" class="padding_10">
      <el-form :model="goodsForm"  :rules="goodsRules" label-width="120px"  ref="addForm">
        <el-form-item label="商品名称" prop="name" >
          <el-input v-model="goodsForm.name" auto-complete="off" placeholder="请输入商品名称"></el-input>
        </el-form-item>
        <el-form-item label="英文名称" prop="en_name" >
          <el-input v-model="goodsForm.en_name" auto-complete="off" placeholder="请输入英文名称"></el-input>
        </el-form-item>
        <el-form-item label="所属游戏" prop="game_id" >
          <el-select v-model="goodsForm.game_id" placeholder="请选择" style="width: 100%">
            <el-option
              v-for="item in games"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品ID" prop="commodity_id" >
          <el-input v-model="goodsForm.commodity_id" auto-complete="off" placeholder="请输入商品ID"></el-input>
        </el-form-item>
        <el-form-item label="所属平台" prop="platform" >
          <el-select v-model="goodsForm.platform" placeholder="请选择" style="width: 100%">
            <el-option
              v-for="item in platform"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品价格" prop="price" >
          <el-input v-model="goodsForm.price" auto-complete="off" placeholder="请输入商品价格">
            <template slot="prepend">$</template>
          </el-input>
        </el-form-item>
        <el-form-item label="适用的appid" prop="appids" >
          <el-input v-model="goodsForm.appids" auto-complete="off" placeholder="多个用逗号隔开"></el-input>
        </el-form-item>
        <el-form-item label="图片" prop="file_id"  style="text-align: left!important;">
          <el-upload
            class="upload-demo"
            action="#"
            :on-change="handleChange"
            :http-request="uploadImg"
            list-type="picture-card"
            :show-file-list="false"
            v-model="goodsForm.file_id"
            ref="upload"
          >
            <img v-if="file_info" :src="file_info" class="avatar" style="width: 146px!important;height: 146px;">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <span style="color: red;font-size: 14px;margin-left: 8px">44px*44px
              </span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" :loading="addLoading" @click="add('addForm')">保 存</el-button>
        <el-button size="small" @click="callOf('addForm')">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="dialogTitle" :visible.sync="dialogEditVisible" :close-on-click-modal="false" width="600px" class="padding_10">
      <el-form :model="goodsForm"  :rules="goodsRules" label-width="120px"  ref="editForm">
        <el-form-item label="商品名称" prop="name" >
          <el-input v-model="goodsForm.name" auto-complete="off" placeholder="请输入商品名称"></el-input>
        </el-form-item>
        <el-form-item label="英文名称" prop="en_name" >
          <el-input v-model="goodsForm.en_name" auto-complete="off" placeholder="请输入英文名称"></el-input>
        </el-form-item>
        <el-form-item label="所属游戏" prop="game_id" >
          <el-select v-model="goodsForm.game_id" placeholder="请选择" style="width: 100%">
            <el-option
              v-for="item in games"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品ID" prop="commodity_id" >
          <el-input v-model="goodsForm.commodity_id" auto-complete="off" placeholder="请输入商品ID"></el-input>
        </el-form-item>
        <el-form-item label="所属平台" prop="platform" >
          <el-select v-model="goodsForm.platform" placeholder="请选择" style="width: 100%">
            <el-option
              v-for="item in platform"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品价格" prop="price" >
          <el-input v-model="goodsForm.price" auto-complete="off" placeholder="请输入商品价格">
            <template slot="prepend">$</template>
          </el-input>
        </el-form-item>
        <el-form-item label="适用的appid" prop="appids" >
          <el-input v-model="goodsForm.appids" auto-complete="off" placeholder="多个用逗号隔开"></el-input>
        </el-form-item>
        <el-form-item label="图片" prop="file_id"  style="text-align: left!important;">
          <el-upload
            class="upload-demo"
            action="#"
            :on-change="handleChange"
            :http-request="uploadImg"
            list-type="picture-card"
            :show-file-list="false"
            v-model="goodsForm.file_id"
            ref="upload"
          >
            <img v-if="file_info" :src="file_info" class="avatar" style="width: 146px!important;height: 146px;">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <span style="color: red;font-size: 14px;margin-left: 8px">44px*44px
              </span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" :loading="editLoading" @click="edit('editForm')">保 存</el-button>
        <el-button size="small" @click="callOf('editForm')">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {goodsList, goodsChangeStatus, delGoods, games, addGoods, getInfo, editGoods} from '../../api/goods'
import {uploadImg} from '../../api'
export default {
  data () {
    return {
      editLoading: false,
      addLoading: false,
      page: 1,
      page_size: 50,
      total: 0,
      tableData: [],
      games: [],
      platform: [
        {
          id: 2,
          name: 'Android'
        },
        {
          id: 3,
          name: 'IOS'
        },
        {
          id: 1,
          name: 'ALL'
        }
      ],
      dialogTitle: '',
      dialogAddVisible: false,
      dialogEditVisible: false,
      goodsForm: {
        id: 0,
        name: '',
        en_name: '',
        game_id: '',
        commodity_id: '',
        appids: '',
        platform: '',
        price: '',
        file_id: ''
      },
      goodsRules: {
        name: [
          { required: true, message: '请输入商品名称', trigger: 'blur' }
        ],
        en_name: [
          { required: true, message: '请输入商品英文名称', trigger: 'blur' }
        ],
        commodity_id: [
          { required: true, message: '请输入商品ID', trigger: 'blur' }
        ],
        appids: [
          { required: true, message: '请输入适用的appid', trigger: 'blur' }
        ],
        price: [
          { required: true, message: '请输入商品价格', trigger: 'blur' }
        ],
        game_id: [
          { required: true, message: '请選擇商品所属游戏', trigger: 'change' }
        ],
        platform: [
          { required: true, message: '请選擇商品所属平台', trigger: 'change' }
        ],
        file_id: [
          { required: true, message: '请上传图片', trigger: 'change' }
        ]
      },
      file_info: '',
      file: {},
      gamesList: [],
      game_id: [],
      order_column: '',
      order_mode: ''
    }
  },
  mounted () {
    // 页面数据初始化表格数据
    if (this.$route.query.id) {
      this.game_id.push(this.$route.query.id)
    }
    this.setTableData()
    this.setGames()
  },
  methods: {
    // 页码切换回调
    handleCurrentChange (val) {
      this.page = val
      this.setTableData()
    },
    // 每页数据数切换
    handleSizeChange (val) {
      this.page_size = val
      this.setTableData()
    },
    // 表格数据填充
    setTableData () {
      goodsList({
        page: this.page,
        page_size: this.page_size,
        game_id: this.game_id,
        order: this.order_column,
        order_mode: this.order_mode
      }).then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.tableData = res.data.table_list
          this.total = res.data.total
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
      })
    },
    // 更改状态
    handleChangeStatus (row, column, rowColumn) {
      goodsChangeStatus({
        id: row.id,
        column: column,
        status: row[rowColumn]
      }).then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.$notify({
            message: message,
            type: 'success',
            offset: 100,
            showClose: false
          })
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
        this.setTableData()
      })
    },
    // 打开添加弹窗
    addDialog () {
      this.dialogTitle = '新增商品'
      this.dialogAddVisible = true
      this.file_info = ''
      this.goodsForm.file_id = ''
    },
    // 关闭弹窗
    callOf (formName) {
      if (formName === 'addForm') {
        this.dialogAddVisible = false
      } else if (formName === 'editForm') {
        this.dialogEditVisible = false
      }
      if (formName) {
        this.$refs[formName].resetFields()
      }
    },
    // 添加资讯
    add (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addLoading = true
          addGoods(this.goodsForm).then(res => {
            let {status, message} = res
            if (status === 2000) {
              this.$notify({
                message: message,
                type: 'success',
                offset: 100,
                showClose: false
              })
              this.setTableData()
              this.dialogAddVisible = false
              this.$refs[formName].resetFields()
            } else {
              this.$notify({
                message: message,
                type: 'warning',
                offset: 100,
                showClose: false
              })
            }
            this.addLoading = false
          })
        }
      })
    },
    // 打开编辑弹窗
    editDialog (id) {
      this.dialogTitle = '编辑商品'
      this.dialogEditVisible = true
      this.file_info = ''
      this.goodsForm.file_id = ''
      getInfo({id: id}).then(res => {
        let {status, message} = res
        if (status === 2000) {
          let data = res.data
          this.goodsForm = {
            id: data.id,
            name: data.name,
            en_name: data.en_name,
            game_id: data.game_id,
            commodity_id: data.commodity_id,
            appids: data.appids,
            platform: data.platform,
            price: data.price,
            file_id: data.file_id
          }
          if (res.data.file_id) {
            this.file_info = res.data.icon
          } else {
            this.file_info = ''
          }
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
      })
    },
    // 修改资讯
    edit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.editLoading = true
          editGoods(this.goodsForm).then(res => {
            let {status, message} = res
            if (status === 2000) {
              this.$notify({
                message: message,
                type: 'success',
                offset: 100,
                showClose: false
              })
              this.setTableData()
              this.dialogEditVisible = false
              this.$refs[formName].resetFields()
            } else {
              this.$notify({
                message: message,
                type: 'warning',
                offset: 100,
                showClose: false
              })
            }
            this.editLoading = false
          })
        }
      })
    },
    // 删除资讯
    del (id) {
      delGoods({
        id: id
      }).then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.$notify({
            message: message,
            type: 'success',
            offset: 100,
            showClose: false
          })
          this.setTableData()
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
      })
    },
    // 上传前回调
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg'
      const isPng = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isJPG || !isPng) {
        this.$notify({
          message: '上传图片必须为jpg或png 格式!',
          type: 'warning',
          offset: 100,
          showClose: false
        })
      }
      if (!isLt2M) {
        this.$notify({
          message: '上传图片大小不能超过 2MB!',
          type: 'warning',
          offset: 100,
          showClose: false
        })
      }
      return isJPG && isLt2M && isPng
    },
    // 上传文件，获取文件流
    handleChange (file) {
      this.file = file.raw
    },
    // 图片上传
    uploadImg () {
      // 创建表单对象
      let form = new FormData()
      // 后端接受参数 ，可以接受多个参数
      form.append('file', this.file)
      uploadImg(form).then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.goodsForm.file_id = res.data.file_id
          this.file_info = res.data.file_path
          this.$refs.upload.clearFiles()
          this.$notify({
            message: message,
            type: 'success',
            offset: 100,
            showClose: false
          })
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
      })
    },
    // 获取所有游戏
    setGames () {
      games().then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.games = res.data
          for (let i of this.games) {
            this.gamesList.push({ text: i.name, value: i.id })
          }
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
      })
    },
    // 筛选监听
    filterStatusHandler (value) {
      if (value.game_id) {
        this.game_id = value.game_id
      }
      this.page = 1
      this.setTableData()
    },
    // 排序改變回調
    changeColumnSort (field) {
      if (field.order) {
        this.order_column = field.prop
        this.order_mode = field.order === 'ascending' ? 'asc' : 'desc'
      } else {
        this.order_column = ''
        this.order_mode = ''
      }
      this.setTableData()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/goods/index.vue